import { render, staticRenderFns } from "./Achievment.vue?vue&type=template&id=0b6816e8&"
import script from "./Achievment.vue?vue&type=script&lang=js&"
export * from "./Achievment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports